import type { CSSProperties } from 'react';
import ArrowUpRightIconSvg from '../../assets/icons/arrow_up_right.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const ArrowUpRightIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        ...style,
    };

    return <ArrowUpRightIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default ArrowUpRightIcon;
